import React from "react";
import { getInitials } from "src/helpers/settingsHelper";
import { Loader2 } from "../LoadingAnimations/Loader2";
import { ArrowRightIcon, XMarkIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const ConnectorList = ({ connectorsLoaded, connectors, onSelect, loadingConnector }) => {
  const isAnyLoading = !!loadingConnector;

  if (!connectorsLoaded) {
    return (
      <div className="flex h-64 flex-col items-center justify-center space-y-3">
        <Loader2 size="xl" />
      </div>
    );
  }

  return (
    <table className="min-w-full table-auto border-separate border-spacing-0">
      <thead>
        <tr className="bg-gray-50/50">
          <th className="border-b border-gray-100 px-6 py-4 text-left text-xs font-bold uppercase tracking-wider text-gray-500">Service Provider</th>
          <th className="border-b border-gray-100 px-6 py-4 text-center text-xs font-bold uppercase tracking-wider text-gray-500">Connection Status</th>
          <th className="border-b border-gray-100 px-6 py-4 text-right text-xs font-bold uppercase tracking-wider text-gray-500">Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {connectors.length > 0 ? (
          connectors.map((connector, i) => {
            const isLoading = loadingConnector === connector.name;
            const isAuthorized = connector.authorization_status === "success";

            return (
              <tr
                key={i}
                className="group transition-all hover:bg-blue-50/30">
                <td className="whitespace-nowrap px-6 py-4">
                  <div className="flex items-center gap-4">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-highlightColor text-sm font-bold text-white shadow-inner transition-colors">{getInitials(connector.title)}</div>
                    <div>
                      <div className="text-sm font-semibold leading-none text-gray-900">{connector.title}</div>
                    </div>
                  </div>
                </td>

                <td className="whitespace-nowrap px-6 py-4">
                  <div className="flex justify-center">
                    {isAuthorized ? (
                      <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700 ring-1 ring-inset ring-emerald-600/20">
                        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-600" />
                        Active
                      </span>
                    ) : (
                      <span className="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-bold text-gray-500">Inactive</span>
                    )}
                  </div>
                </td>

                <td className="whitespace-nowrap p-4 text-right">
                  <button
                    onClick={() => onSelect(connector)}
                    disabled={isAnyLoading}
                    className={`inline-flex min-w-[110px] items-center justify-center gap-2 rounded-lg px-3 py-2 text-xs font-bold tracking-wide transition-all
                      ${isAnyLoading ? "cursor-not-allowed bg-gray-50 text-gray-300" : isAuthorized ? "border border-red-100 bg-red-50 text-red-600 hover:bg-red-600 hover:text-white" : "bg-highlightColor text-white shadow-sm hover:opacity-90 hover:shadow-md"}`}>
                    {isLoading ? (
                      <Loader2
                        size="sm"
                        className="mr-0"
                        containerClasses="!p-0"
                      />
                    ) : isAuthorized ? (
                      <>
                        <XMarkIcon className="h-3.5 w-3.5" />
                        Disconnect
                      </>
                    ) : (
                      <>
                        Connect
                        <ArrowRightIcon className="h-3.5 w-3.5" />
                      </>
                    )}
                  </button>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td
              colSpan="3"
              className="py-20">
              <div className="flex flex-col items-center justify-center text-center">
                <div className="mb-4 rounded-full bg-gray-50 p-4">
                  <MagnifyingGlassIcon className="h-8 w-8 text-gray-300" />
                </div>
                <h3 className="text-sm font-semibold text-gray-900">No connectors found</h3>
                <p className="mt-1 text-xs text-gray-500">We couldn't find any services matching your search.</p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default ConnectorList;
